import {autoChangeBanners} from './banners';
import lazySizes from 'lazysizes';
lazySizes.cfg.loadMode = 1;
lazySizes.cfg.preloadAfterLoad = false;
lazySizes.cfg.init = false;
lazySizes.cfg.loadHidden  = true;

(() => {

    function loadImages(images) {

        if (typeof images !== 'undefined'){
            try {
                $.each(images, function (idx,img){
                    lazySizes.loader.unveil(img)
                });
            }catch (err){

            }
        }

        lazySizes.init();
    }

    loadImages();

    $.each($('.bnrs-group'), function (index, group) {
        let timeout = parseInt($(group).data('timeout'), 10);
        if (typeof timeout !== 'number' || isNaN(timeout)) {
            timeout = 10;
        }
        if (timeout < 5) {
            timeout = 5;
        }
        timeout = timeout * 1000;
        timeout = 7000;
        setInterval(function () {
            autoChangeBanners($(group)).then(function () {
                if (lazySizes.cfg.loadHidden !== true){
                    lazySizes.cfg.loadHidden  = true;
                }
                loadImages($(group).find('img'));
            });
        }, timeout);

    });

})();
